/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment processors — Polar.sh for subscription billing and payment processing.`)
};

const es_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesadores de pago — Polar.sh para facturación de suscripciones y procesamiento de pagos.`)
};

const de_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungsdienstleister — Polar.sh für Abo-Abrechnung und Zahlungsabwicklung.`)
};

const nl_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingsverwerkers — Polar.sh voor abonnementsfacturering en betalingsverwerking.`)
};

const fr_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processeurs de paiement — Polar.sh pour la facturation des abonnements et le traitement des paiements.`)
};

const it_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaboratori di pagamento — Polar.sh per la fatturazione degli abbonamenti e l’elaborazione dei pagamenti.`)
};

const pt_br2_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processadores de pagamento — Polar.sh para cobrança de assinaturas e processamento de pagamentos.`)
};

const pt_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processadores de pagamento — Polar.sh para faturação de subscrições e processamento de pagamentos.`)
};

const ja_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決済処理業者 — サブスクリプション請求と決済処理のためのPolar.sh。`)
};

const zh_privacy_third_party_payment = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付处理商 — Polar.sh用于订阅计费和支付处理。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_third_party_payment = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_third_party_payment(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_third_party_payment", locale)
	if (locale === "en") return en_privacy_third_party_payment(inputs)
	if (locale === "es") return es_privacy_third_party_payment(inputs)
	if (locale === "de") return de_privacy_third_party_payment(inputs)
	if (locale === "nl") return nl_privacy_third_party_payment(inputs)
	if (locale === "fr") return fr_privacy_third_party_payment(inputs)
	if (locale === "it") return it_privacy_third_party_payment(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_third_party_payment(inputs)
	if (locale === "pt") return pt_privacy_third_party_payment(inputs)
	if (locale === "ja") return ja_privacy_third_party_payment(inputs)
	return zh_privacy_third_party_payment(inputs)
};